import useSWR from 'swr';

export interface SettingsValues {
  syncHour: string;
  syncHourEmail: string;
  maintenance: boolean;
  contactEmail: string;
  contact_email_cc: string;
  clasificationCMessage: string;
  syncErrorInterval: number;
  syncInterval: number;
  buyRemainingTime: number;
  buyBccConfirmation: string;
  loyaltyUrl: string;
  currentIosApp: string;
  minIosApp: string;
  currentAndroidApp: string;
  minAndroidApp: string;
  buysToCompleteQty: number;
  bookingFee: number;
  conektaFeePercent: number;
  requiredVisitsForLevel2: number;
  requiredVisitsForLevel3: number;
  noClasificationMovieDisclaimer: string;
  clasificationCDisclaimer: string;
  allowPaymentWithPoints: number;
  enableSpamValidation: boolean;
  spamValidationConfig: {
    limitTimesBlocked: number;
    limitTimeInMinutes: number;
    limitBuysPerTime: number;
    blockDays: number;
  };
  smsConfig: {
    auth: {
      email: string;
      password: string;
      ttl: number;
    };
    session: {
      token?: string;
      expiresAt?: string;
    };
    baseURL: string;
    message: string;
    script: number;
    country: 1;
  };
}

// Versión con tipos específicos según la clave
function useSettings(): SettingsValues | undefined;
function useSettings<K extends keyof SettingsValues>(key: K): SettingsValues[K] | undefined;
function useSettings<K extends keyof SettingsValues>(key?: K) {
  const { data } = useSWR<SettingsValues>('/settings');
  return key ? data?.[key] : data;
}

export default useSettings;
